/**
 * Parses a form numeric string for the live margin preview only — `null` for empty/invalid input
 * so the caller falls back to the package's live value. Full validation happens in
 * `buildSocieteRewardAction` on submit.
 */
export function parseFormNumber(value: string | undefined): number | null {
  if (!value || value.trim() === '') return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
}
